import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import React from 'react';
import { getConsumerImageUrl } from '../utils/getConsumerImageUrl';
import { PersonaControl, PersonaControlProps } from 'owa-persona';

export type UserPersonaControlProps = Omit<PersonaControlProps, 'name' | 'emailAddress'>;

export const UserPersonaControl = (props: UserPersonaControlProps) => {
    const { ...rest } = props;

    const {
        SessionSettings: { UserEmailAddress, UserDisplayName },
        HexCID,
    } = getUserConfiguration();

    const imageUrl = isConsumer() ? getConsumerImageUrl(HexCID) : undefined;

    return (
        <PersonaControl
            name={UserDisplayName}
            emailAddress={UserEmailAddress}
            imageUrl={imageUrl}
            {...rest}
        />
    );
};
